import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import ProcessorRuleList from 'components/ProcessorRule/List';

const ScreenProcessorRuleList = ({ routePaths, target, titleKey }) => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <ProcessorRuleList
          initialFilters={initialFilters}
          routePaths={routePaths}
          target={target}
          titleKey={titleKey}
        />
      </GridItem>
    </GridContainer>
  );
};

ScreenProcessorRuleList.propTypes = {
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
  titleKey: PropTypes.string,
};

ScreenProcessorRuleList.defaultProps = {
  routePaths: undefined,
  target: undefined,
  titleKey: undefined,
};

export default ScreenProcessorRuleList;
